import { Layout, StockList, AddStock , View, StockTransaction, DividendReport, AddDividend, ImportDividend, StockAnalysis } from '@/views/stock';

export default {
    path: '/stock',
    component: Layout,
    children: [
        { path: 'list', component: StockList },
        { path: 'add', component: AddStock },
        { path: 'view', component: View },
        { path: 'analysis', component: StockAnalysis },
        { path: 'stock-transaction', component: StockTransaction },
        { path: 'dividend-report', component: DividendReport },
        { path: 'add-dividend', component: AddDividend },
        { path: 'import-dividend', component: ImportDividend },
    ]
};
